import { useStore } from '@xyflow/react';

/**
 * Returns true when 2 or more nodes are currently selected.
 */
export function useIsMultiSelected(): boolean {
  return useStore((state) => {
    let count = 0;
    for (const n of state.nodes) {
      if (n.selected && ++count >= 2) return true;
    }
    return false;
  });
}
